import axios from "axios";
import { useAuth } from "react-oidc-context";
import { toast } from "react-toastify";
import { getBaseApiUrl } from "../utils/environment";
import {
  isTenantUnavailableError,
  TENANT_UNAVAILABLE_MESSAGE,
} from "../utils/errorToast";
import { getTenantHeader } from "./tenantConfig";

let sessionExpiredShown = false;

const useAxiosInstance = () => {
  const auth = useAuth();

  const axiosInstance = axios.create({
    baseURL: getBaseApiUrl(),
    headers: {
      "Content-Type": "application/json",
    },
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      if (auth.isAuthenticated) {
        config.headers.Authorization = `Bearer ${auth.user?.access_token}`;
      }

      config.headers["X-Tenant-ID"] = getTenantHeader();

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (isTenantUnavailableError(error) && !sessionExpiredShown) {
        toast.error(TENANT_UNAVAILABLE_MESSAGE);
        sessionExpiredShown = true;
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxiosInstance;
